module.exports = __webpack_public_path__ + "img/logo-white-escudo.3ccf57fc.svg";